import { BaseComponent } from '@pixelart/component-handler';

export class Tracking extends BaseComponent {

    protected BTN_SELECTOR: string = '.tracking__btn';
    protected MSG_SELECTOR: string = '.tracking__message-state';
    private trackingBtn: JQuery;
    private trackingMsg: JQuery;
    private messageEnable: string;
    private messageDisable: string;
    private messageActive: string;
    private messageInactive: string;

    constructor(element: Element) {
        super(element);
    }

    public init() {
        this.trackingBtn = this.$element.find(this.BTN_SELECTOR);
        this.trackingMsg = this.$element.find(this.MSG_SELECTOR);
        this.messageEnable = this.trackingBtn.data('optout-enable');
        this.messageDisable = this.trackingBtn.data('optout-disable');
        this.messageActive = this.trackingBtn.data('optout-active');
        this.messageInactive = this.trackingBtn.data('optout-inactive');

        this.initTrackingBtn();
    }

    // destroy
    public destroy() {
        // destroy
    }

    public initTrackingBtn() {
        this.trackingBtn.on('click', () => {
           this.toggleTracking();
        });

        if (window.localStorage.getItem('tracking')) {
            this.enableTracking();
        } else {
            this.disableTracking();
        }
    }

    public toggleTracking() {
        if (window.localStorage.getItem('tracking')) {
            window.localStorage.removeItem('tracking');
            this.disableTracking();
        } else {
            window.localStorage.setItem('tracking', 'false');
            this.enableTracking();
        }
    }

    public enableTracking() {
        this.trackingBtn.text(this.messageEnable);
        this.trackingMsg.text(this.messageInactive);
    }

    public disableTracking() {
        this.trackingBtn.text(this.messageDisable);
        this.trackingMsg.text(this.messageActive);
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./assets/components/tracking/tracking.class.ts